module.exports = __webpack_public_path__ + "static/media/faq.82a1fcb1.svg";